import { forwardRef, useState } from "react";
import { Box, Flex, Text, Textarea, Input as TInput } from "theme-ui";
import { ChevronDown } from "react-feather";

import { InputProps } from "./Input.d";

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      value,
      type,
      label,
      message,
      error,
      rows,
      onValueChange,
      onFocus,
      onBlur,
      ...rest
    },
    ref
  ) => {
    const [focused, setFocused] = useState(false);
    const isFocused = focused || !!String(value).length;

    const commonStyles = {
      borderRadius: 0,
      border: "none",
      borderBottom: "1px solid",
      borderBottomColor: "grey",
      color: "primary",
      fontSize: 3,
      width: "100%",
      backgroundColor: "transparent",
      outline: "none",
      px: 0,
      py: 1,
      transition: "border 0.3s ease-out",
      zIndex: 2,
    };

    const getElement = () => {
      switch (type) {
        case "select":
          return (
            <>
              <Text
                sx={{ ...commonStyles, cursor: "pointer", textAlign: "left" }}
              >
                {value}&#10240;
              </Text>
              {!value && (
                <Box sx={{ position: "absolute", right: 0, color: "grey" }}>
                  <ChevronDown />
                </Box>
              )}
            </>
          );

        case "text":
          return (
            <TInput
              sx={commonStyles}
              value={value}
              type="text"
              onChange={(e) => onValueChange?.(e.target.value)}
              onFocus={() => {
                setFocused(true);
                onFocus?.();
              }}
              onBlur={() => {
                setFocused(false);
                onBlur?.();
              }}
              ref={ref}
            />
          );

        case "textArea":
          return (
            <Textarea
              sx={commonStyles}
              rows={rows}
              value={value}
              onChange={(e) => onValueChange?.(e.target.value)}
              onFocus={() => {
                setFocused(true);
                onFocus?.();
              }}
              onBlur={() => {
                setFocused(false);
                onBlur?.();
              }}
            />
          );

        default:
          break;
      }
    };

    return (
      <>
        <Flex
          {...rest}
          sx={{
            flexDirection: "column",
            my: 2,
            position: "relative",
            width: "100%",
          }}
        >
          {label && (
            <Text
              as="label"
              sx={{
                position: "absolute",
                top: "8px",
                left: "1px",
                transition: "all 0.1s ease-in",
                fontSize: 2,
                color: isFocused ? "accent" : "grey",
                transform: isFocused ? "translateY(-24px)" : "none",
                zIndex: 1,
              }}
            >
              {label}
            </Text>
          )}
          {getElement()}
          <Flex
            sx={{
              position: "absolute",
              width: "100%",
              bottom: "-24px",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <Text sx={{ fontSize: 1, color: "secondary" }}>{error}</Text>
            <Text sx={{ fontSize: 1 }}>{message}</Text>
          </Flex>
        </Flex>
      </>
    );
  }
);
